export const RESOURCE_TYPE = {
  PLATFORM: 'platform',
  WORKSPACE: 'workspace',
};
